import { render, staticRenderFns } from "./DispatchOrder.vue?vue&type=template&id=91285348&scoped=true&"
import script from "./DispatchOrder.vue?vue&type=script&lang=js&"
export * from "./DispatchOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91285348",
  null
  
)

export default component.exports